'use strict';
module.exports = require('./Password.vue');